import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

import Loading from "../../layout/Loading";
import useAPICall from "../../../hooks/fetch-hooks/useAPICall";
import { useAuthInfo } from "../../../context/AuthContext";
import { successfulToast } from "../../../util/toastNotifications";
import Logo from "../../../assets/images/logo.svg";

export default function AccountVerifed(props) {
  const verificationCode = props.match.params.encoded;
  const { isLoading, error } = useAPICall(
    `/auth/verify-email/${verificationCode}`,
    "PUT",
    null,
    null
  );
  const { logout } = useAuthInfo();
  const hasShownToast = useRef(false);

  useEffect(() => {
    if (!isLoading && !error && !hasShownToast.current) {
      hasShownToast.current = true;
      successfulToast("Email verified. You can now log in.");
      logout({ suppressErrorToast: true });
    }
  }, [isLoading, error, logout]);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="mt-32 center">
      <Link to="/login">
        <img className="mb-16 height-10" src={Logo} alt="Logo" />
      </Link>

      {!error ? (
        <div className="width-600px height-600px py-8 px-16 card center">
          <h2>Email Address Successfully Verified</h2>
          <p>Thank you for verifying your email address.</p>
          <p>You can now log in to your account using the button below.</p>
          <Link to="/login">
            <button>Login</button>
          </Link>
        </div>
      ) : (
        <div className="width-600px height-600px py-8 px-16 card center">
          <h2 className="error">Your Verification Link Has Expired</h2>

          <p>Click the button below to request a new link</p>
          <Link to="/login/verify-account">
            <button>Request New Verification Link</button>
          </Link>
        </div>
      )}
    </div>
  );
}
